import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import CorporateDashboardLayout from "src/layouts/CorporateDashboard/index.js";
import { decryptData } from "src/utils/decryptcookie";
import LoadingScreen from "../../../../components/LoadingScreen.js";
import AuthGuard from "src/guards/AuthGuard.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

const TransactionPage = Loadable(
  lazy(() => import("src/pages/AccountsDepartment/TransactionPage.js"))
);
const CorporateList = Loadable(
  lazy(() =>
    import("src/components/_corporate/CorporateList/CorporateList.jsx")
  )
);

const FlightInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/FlightInvoice.js"))
);
const HotelInvoice = Loadable(
  lazy(() => import("src/pages/dashboard/invoice/HotelInvoice.js"))
);

// agent different routes than admin
const TransferPnr = Loadable(
  lazy(() => import("src/components/_dashboard/transferPnr/TransferPnr.js"))
);

// Main
const FlightBooking = Loadable(
  lazy(() => import("src/pages/Flightbooking.js"))
);
const HotelBooking = Loadable(
  lazy(() => import("src/pages/hotels/menu/HotelBookingPage.js"))
);

const Topup = Loadable(
  lazy(() => import("src/components/_dashboard/Transaction/TopUp.js"))
);

const FlightBookingsHistory = Loadable(
  lazy(() => import("src/pages/Bookings/userBookings.js"))
);

const HotelBookingTablePage = Loadable(
  lazy(() => import("src/pages/hotels/menu/HotelBookingTablePage.js"))
);

// sub-agent 
const AddEmployeeForm = Loadable(
  lazy(() => import("src/pages/_corporate/AddEmployeeForm/AddEmployeeForm.js"))
);

const BookingsHistory = Loadable(
  lazy(() => import("src/pages/Bookings/userBookings"))
);

export const CorporateEmployeeRoutes = () => {
  const parsedData = decryptData("_b60-g6fr_plus");

  return {
    // path: "/dashboard",
    path: "/dashboard",
    element: (
      <AuthGuard>
        <CorporateDashboardLayout />
      </AuthGuard>
    ),

    children: [
      {
        path: "",
        element: <Navigate to={"/dashboard/corporate-employee"} replace />,
      },
      { path: "bookingsHistory", element: <BookingsHistory /> },
      { path: "flight_booking", element: <FlightBooking /> },
      { path: "hotel_booking", element: <HotelBooking /> },

      { path: "invoice_flight", element: <FlightInvoice /> },
      { path: "invoice_hotel", element: <HotelInvoice /> },
      //   { path: "trans", element: <Transaction /> }, // user transaction
      { path: "topup", element: <Topup /> },
      { path: "bookingsHistory", element: <FlightBookingsHistory /> },
      { path: "accounts-all-requests", element: <TransactionPage /> },

      // sub-agent-action - corporate

      //   { path: "sub-agent-info", element: <SubAgentTable /> },
    //   { path: "transfer-pnr", element: <TransferPnr /> },
      // new route
      {
        path: "all-booking-details-hotels",
        element: <HotelBookingTablePage />,
      },
    ],
  };
};
